<template>
  <b-modal
    ref="sql-message-modal-ref"
    hide-footer
    hide-header
    :title="payload.title"
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">
          {{ payload.title }}
        </h5>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeModal"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div
        v-if="payload.sqlCodes || payload.message"
        class="vtd-modal-body"
      >
        <div v-if="flightsWithOptionDate.length && fil === 'M'">
          <div
            v-for="flight in flightsWithOptionDate"
            :key="flight.option_date"
          >
            <p class="mb-2">
              <strong>Your {{ toTitleCase(flight.airline) }} ticket {{ flight.tense }} issued on {{
                toTitleCase(flight.option_date) }}.</strong>
            </p>
          </div>
        </div>
        <div
          v-for="msgBlock in payload.sqlCodes"
          :key="msgBlock.code"
          class="message"
        >
          <p
            v-show="msgBlock.title"
            style="text-align: left"
          >
            {{ msgBlock.title }}
          </p>
          <div
            style="text-align: left"
            v-html="msgBlock.content"
          />
        </div>

        <!-- Free text notes sent straight from vt-api rather than looked up by
             code, e.g. the Ryanair post booking and terms notes -->
        <div
          v-for="(msgBlock, index) in payload.message"
          :key="`message-${index}`"
          class="message"
        >
          <p
            v-show="msgBlock.title"
            style="text-align: left"
          >
            {{ msgBlock.title }}
          </p>
          <div
            style="text-align: left"
            v-html="msgBlock.editedtext"
          />
        </div>

        <ServiceErrorMessage :error-loading-data="errorLoadingData" />
      </div>
      <div v-else>
        <p class="mb-0">
          No seating information found for your booking.
        </p>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small>This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { loadSQLData } from "./services";
import { mapGetters } from 'vuex';
import ServiceErrorMessage from "@/partials/service-error-message";
export default {
  components: { ServiceErrorMessage },
  data() {
    return {
      payload: {},
      errorLoadingData: false,
      flightsWithOptionDate: []
    };
  },
  mounted() {
    this.flightsWithOptionDate = [];
    if (this.booking) {
    for (
      let i = 0;
      i < this.booking.booking_itinerary.itinerary.length;
      i++
    ) {
      for (
        let j = 0;
        j < this.booking.booking_itinerary.itinerary[i].data.length;
        j++
      ) {
        if (
          this.booking.booking_itinerary.itinerary[i].data[j].hasOwnProperty(
            "optiondate"
          ) &&
          this.booking.booking_itinerary.itinerary[i].data[j].optiondate !==
          ""
        ) {
          let _dat = dayjs(
            this.booking.booking_itinerary.itinerary[i].data[j].optiondate,
            "DD-MMM-YYYY"
          )
          let _tense = _dat.isBefore(dayjs()) ? 'was' : 'is due to be';
          this.flightsWithOptionDate.push({ 'airline': this.booking.booking_itinerary.itinerary[i].data[j].suppliername, 'option_date': this.booking.booking_itinerary.itinerary[i].data[j].optiondate, 'tense': _tense });
        }
      }
    }
  }
  },
  methods: {
    toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
    },
    async showModal(payload) {
      this.payload = {};
      // Show loading spinner on top of the modal
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      // Loop over message codes and get data from SQL
      // We have to do it everytime because this modal is used by different options
      if (payload.sqlCodes) {
        for (const codeObj of payload.sqlCodes) {
          let result = await loadSQLData({ codes: [codeObj.code] });
          if (result.error === true) {
            this.errorLoadingData = true;
            break;
          }
          if (result.data) {
            codeObj.content = result.data[0].message;
          }
        }
        this.payload = payload;
        // Close spinner
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });

        this.$refs["sql-message-modal-ref"].show();
      } else {
        // Nothing to look up, but the payload may still carry free text notes
        this.payload = payload;
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });

        this.$refs["sql-message-modal-ref"].show();
      }
    },

    closeModal() {
      this.$refs["sql-message-modal-ref"].hide();
    }
  },
  computed: {
    ...mapGetters({
      booking: "booking/getBooking",
      fil: "booking/getFil",
    }),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    }
  },
};
</script>
<style lang="scss">
@import "./style.scss";

.message {
  margin-bottom: 20px;
}
</style>
